import LayoutHeader, {LayoutHeaderIconTypes, LayoutHeaderColorTypes} from './LayoutHeader';

export {LayoutHeaderIconTypes, LayoutHeaderColorTypes};
export default LayoutHeader;
